import { QueryClient } from 'react-query';
import { createLocalStoragePersistor } from 'react-query/createLocalStoragePersistor-experimental';
import { persistQueryClient } from 'react-query/persistQueryClient-experimental';

const queryClient = new QueryClient();
const persistor = createLocalStoragePersistor();
persistQueryClient({ queryClient, persistor });

export function refetchQueries(): void {
  queryClient.refetchQueries({ stale: true, active: true });
}

export { queryClient };
